import React from "react";
import { Col, Form } from "antd";
import Inputs from "../../../../biblio/Inputs/Inputs";

const NationalAddressForm = () => {
  return (
    <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
      <Form.Item
        name="national_address"
        label="إسم الشارع و رقم المبنى"
        rules={[
          {
            required: true,
            message: "الرجاء تعبئة الحقل",
          },
        ]}
        labelCol={{ className: "takaful--label-style" }}
      >
        <Inputs type="text" />
      </Form.Item>
    </Col>
  );
};

export default NationalAddressForm;
